module.exports = __webpack_public_path__ + "img/link-banner-jp.08bb33f3.png";